// extracted by mini-css-extract-plugin
export var defaultStyles = "markdown-module--default-styles--15ef6";
export var imageHolder = "markdown-module--image-holder--25b79";
export var markdown = "markdown-module--markdown--272c3";